import diffArrays from 'helpers/diffArray'

import DetailedDiff from '../@types/DetailedDiff'
import DiseaseType from '../@types/DiseaseType'

type Disease = {
  type: DiseaseType
  name: string
  medications?: string[]
  custom?: boolean
}

export type Type = Disease

export const getKey = (disease: Disease) => `${disease.type}-${disease.name}`

export const getDiff = (original: Disease[], current: Disease[]): DetailedDiff => diffArrays(original, current, getKey)
